import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col, Button, Form, Card, Carousel, Navbar, Nav } from "react-bootstrap";
import {  FaMapMarkedAlt , FaWhatsapp , FaPhoneAlt,FaArrowLeft   } from "react-icons/fa";

import axios from 'axios';
import { site_url, site_url_img } from "./../config.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";
import { useLocation } from 'react-router-dom';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { FaStar,FaUserCircle  } from "react-icons/fa";
import { format } from "date-fns";
import {  Link } from "react-router-dom";
import { AuthContext } from './../AuthContext';

function Index() {
  const [productcategorydata, setproductcategorydata] = useState([]);
  const { user,fulluser } = useContext(AuthContext);

    const location = useLocation();
    const category = location.state?.category;
    const goBack = () => {
        window.history.back(); // Goes back to the previous page
      };

      useEffect(() => {
        console.log(category);
        productsubcategory();
      },[category]);

      const productsubcategory = async () => {
        try {
    
          const response = await axios.get(site_url + '/vendor/productsubcategory/'+category.id);
    
          if (response.data.status == 'success') {
    
            setproductcategorydata(response.data.data);
          }
        } catch (error) {
    
        }
      }


  return (
    <div><div className="min-vh-100">
    {/* Navbar */}
    <Navbar expand="lg" className="navbar px-3">

        <Navbar.Brand className="fw-bold text-white"><center><FaArrowLeft onClick={goBack} className="fs-5 text-white notificaton-icon" /> {category?.name}</center></Navbar.Brand>
        <Nav className="ms-auto d-flex align-items-center">
        </Nav>
    </Navbar>
    <div className="row justify-content-center mt-2 p-2">
      <h4 className='p-2'>Product List</h4>
    {productcategorydata.map((shop, index) => (
    <div className="col-4">
      <Link to={user != null ? `/Shopdetails` : `/signin`} state={{ shop }}>
        <div className="shadow-sm" style={{padding:'6%'}}>
        <img style={{width:'100%',height:'150px',padding:'8%'}} src={site_url_img + '/' + shop.product_image} className="card-img-top" alt="Product Image" />
        <div className="card-body text-center" style={{marginBottom:'2%'}}>
        <p style={{fontSize:'14px',fontWeight:'700',marginTop:'1%'}} className="text-muted">{shop.shop_name}</p>
          <h5 className="card-title">{shop.product_name}</h5>
          <p style={{fontSize:'14px',fontWeight:'700',marginTop:'3%',marginBottom:'2%'}} className="text-muted"><span class="badge badge-success">Best Price</span></p>


      
        </div>
      </div>
      </Link>
    </div>

       ))}
       </div>
    
    </div>
    </div>
  )
}
export default Index